/* =====================================================================
   CIMELLE MAISON — interactions (theme v7)
   Small, dependency-free. Safe to run more than once (theme editor).
   ===================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Tabs (selection) ---------- */
  function initTabs(root) {
    root.querySelectorAll('[data-cm-tabs]').forEach(function (sec) {
      if (sec.__cmTabs) return;
      sec.__cmTabs = true;
      sec.addEventListener('click', function (e) {
        var tab = e.target.closest('.cm-tab');
        if (!tab || !sec.contains(tab)) return;
        showTab(sec, tab.getAttribute('data-tab'));
      });
      sec.addEventListener('keydown', function (e) {
        var tab = e.target.closest('.cm-tab');
        if (!tab) return;
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var tabs = Array.prototype.slice.call(sec.querySelectorAll('.cm-tab'));
        var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
        if (i < 0) i = tabs.length - 1;
        if (i >= tabs.length) i = 0;
        tabs[i].focus();
        showTab(sec, tabs[i].getAttribute('data-tab'));
      });
    });
  }
  function showTab(sec, idx) {
    sec.querySelectorAll('.cm-tab').forEach(function (t) {
      var on = t.getAttribute('data-tab') === String(idx);
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });
    sec.querySelectorAll('.cm-panel').forEach(function (p) {
      var on = p.getAttribute('data-panel') === String(idx);
      p.classList.toggle('is-on', on);
      p.classList.toggle('is-swapped', on);
      if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
    });
  }

  /* ---------- Hero: soft light that follows the pointer ---------- */
  function initHero(root) {
    if (reduceMotion) return;
    root.querySelectorAll('[data-cm-hero]').forEach(function (hero) {
      if (hero.__cmHero) return;
      hero.__cmHero = true;
      var bg = hero.querySelector('.cm-hero-bg');
      if (!bg) return;
      var raf = 0, x = 74, y = 44;
      hero.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        var r = hero.getBoundingClientRect();
        x = ((e.clientX - r.left) / r.width) * 100;
        y = ((e.clientY - r.top) / r.height) * 100;
        if (!raf) raf = requestAnimationFrame(function () {
          raf = 0;
          bg.style.setProperty('--mx', x.toFixed(1) + '%');
          bg.style.setProperty('--my', y.toFixed(1) + '%');
        });
      }, { passive: true });
    });
  }

  /* ---------- Videos: play only while visible ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) {
        if (v.preload === 'none') v.preload = 'metadata';
        if (!reduceMotion) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { rootMargin: '120px 0px', threshold: 0.15 }) : null;

  function initVideos(root) {
    root.querySelectorAll('video[data-cm-vis]').forEach(function (v) {
      if (v.__cmVis) return;
      v.__cmVis = true;
      v.muted = true;
      if (io) io.observe(v);
      else if (!reduceMotion) { v.preload = 'metadata'; v.play && v.play(); }
    });
    if (reduceMotion) {
      root.querySelectorAll('.cm video[autoplay]').forEach(function (v) { try { v.pause(); } catch (e) {} });
    }
  }

  /* ---------- Lens illustration (signature) ---------- */
  function initLens(root) {
    root.querySelectorAll('[data-cm-lens]').forEach(function (w) {
      if (w.__cmLens) return;
      w.__cmLens = true;
      var b = w.querySelector('.cm-lens');
      if (!b) return;
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () {
        var on = !w.classList.contains('is-lit');
        w.classList.toggle('is-lit', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  /* ---------- Finish buttons (signature) ---------- */
  function initTones(root) {
    root.querySelectorAll('[data-cm-tones]').forEach(function (g) {
      if (g.__cmTones) return;
      g.__cmTones = true;
      var sec = g.closest('[data-cm-signature]') || document;
      var buy = sec.querySelector('[data-cm-buy]');
      g.querySelectorAll('.cm-tone').forEach(function (b) {
        b.setAttribute('aria-pressed', b.classList.contains('is-on') ? 'true' : 'false');
      });
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.cm-tone');
        if (!b) return;
        g.querySelectorAll('.cm-tone').forEach(function (x) {
          x.classList.toggle('is-on', x === b);
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        if (buy && b.getAttribute('data-href')) buy.setAttribute('href', b.getAttribute('data-href'));
      });
    });
  }


  /* ---------- Product rails: arrows + gentle autoplay ---------- */
  function initRails(root) {
    root.querySelectorAll('[data-cm-rail]').forEach(function (rail) {
      if (rail.__cmRail) return;
      rail.__cmRail = true;
      var sec = rail.closest('.cm-rail-sec') || rail.parentElement;
      var track = rail.querySelector('.cm-rail-track');
      var until = 0, hold = false, visible = false;
      function step() {
        var it = rail.querySelector('.cm-rail-item');
        var gap = track ? parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0 : 0;
        return it ? it.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
      }
      function go(dir) {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if (max <= 0) return;
        if (dir > 0 && rail.scrollLeft >= max) { rail.scrollTo({ left: 0, behavior: 'smooth' }); return; }
        if (dir < 0 && rail.scrollLeft <= 2) { rail.scrollTo({ left: max, behavior: 'smooth' }); return; }
        rail.scrollBy({ left: dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      function pause(ms) { until = Date.now() + (ms || 9000); }
      sec.querySelectorAll('.cm-rail-btn').forEach(function (b) {
        b.addEventListener('click', function () { go(+b.getAttribute('data-dir')); pause(12000); });
      });
      var every = parseFloat(rail.getAttribute('data-autoplay')) * 1000;
      if (!every || reduceMotion) return;
      rail.addEventListener('pointerenter', function () { hold = true; });
      rail.addEventListener('pointerleave', function () { hold = false; });
      rail.addEventListener('focusin', function () { hold = true; });
      rail.addEventListener('focusout', function () { hold = false; });
      rail.addEventListener('touchstart', function () { pause(15000); }, { passive: true });
      rail.addEventListener('wheel', function () { pause(9000); }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.35 }).observe(rail);
      } else { visible = true; }
      setInterval(function () {
        if (hold || !visible || document.hidden || Date.now() < until) return;
        go(1);
      }, every);
    });
  }

  /* ---------- Motion: reveal headings, eyebrow lines and categories once ---------- */
  var seen = null;
  function initMotion(root) {
    var html = document.documentElement;
    if (reduceMotion || !('IntersectionObserver' in window)) { html.classList.remove('cm-motion'); return; }
    html.classList.add('cm-motion', 'cm-motion-ready');
    if (!seen) {
      seen = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); seen.unobserve(en.target); }
        });
      }, { threshold: 0.3, rootMargin: '0px 0px -6% 0px' });
    }
    root.querySelectorAll('.cm .cm-h2, .cm .cm-eyebrow, .cm-meds').forEach(function (el) {
      if (el.__cmSeen) return;
      el.__cmSeen = true;
      seen.observe(el);
    });
  }

  /* ---------- Mobile menu: categories already open, a quiet signature at the bottom ---------- */
  function initDrawer() {
    var drawer = document.querySelector('.menu-drawer');
    if (!drawer || drawer.__cmDrawer) return;
    drawer.__cmDrawer = true;
    function openGroups() {
      drawer.querySelectorAll('.menu-drawer__menu--childlist details').forEach(function (d) { d.open = true; });
    }
    openGroups();
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('.menu-drawer__menu-item--mainlist')) setTimeout(openGroups, 30);
    });
    var nav = drawer.querySelector('.menu-drawer__navigation');
    if (nav && !nav.querySelector('.cm-drawer-foot')) {
      var foot = document.createElement('div');
      foot.className = 'cm-drawer-foot';
      foot.innerHTML = '<span class="cm-foil">Cimelle</span><p>Free US shipping \u00b7 30-day returns</p>' +
        '<nav><a href="/collections/our-favorites">Our favorites</a><a href="/pages/contact">Contact us</a></nav>';
      nav.appendChild(foot);
    }
  }

  /* ---------- Intro veil: release the page once it has lifted ---------- */
  function endIntro() {
    var html = document.documentElement;
    if (!html.classList.contains('cm-intro')) return;
    window.setTimeout(function () {
      html.classList.add('cm-intro-done');
      var veil = document.querySelector('.cm-veil');
      if (veil) veil.setAttribute('hidden', '');
    }, reduceMotion ? 0 : 3000);
  }

  /* ---------- Header: subtle state once the page scrolls ---------- */
  function initScrollState() {
    if (document.documentElement.__cmScroll) return;
    document.documentElement.__cmScroll = true;
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY || 0;
      var pw = document.querySelector('.page-wrapper');
      if (pw && pw.scrollTop) y = Math.max(y, pw.scrollTop);
      document.documentElement.classList.toggle('cm-scrolled', y > 24);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    update();
  }

  function init(root) {
    root = root || document;
    initTabs(root);
    initHero(root);
    initVideos(root);
    initLens(root);
    initTones(root);
    initRails(root);
    initMotion(root);
  }

  function boot() {
    init(document);
    endIntro();
    initScrollState();
    initDrawer();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* ---------- Theme editor ---------- */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.closest && e.target.closest('.cm-tab');
    if (tab) {
      var sec = tab.closest('[data-cm-tabs]');
      if (sec) showTab(sec, tab.getAttribute('data-tab'));
    }
  });
})();
